// Angular Import
import { Component, OnDestroy, ViewEncapsulation, inject, input, DOCUMENT } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { ChangeDetectorRef, AfterViewInit } from '@angular/core';

// project import
import { Spinkit } from './spinkits';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss', './spinkit-css/sk-line-material.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnDestroy, AfterViewInit {
  private router = inject(Router);
  private document = inject<Document>(DOCUMENT);
  private cd = inject(ChangeDetectorRef);

  // public props
  isSpinnerVisible = true;
  Spinkit = Spinkit;
  backgroundColor = input<string>('#2689E2');
  spinner = input(Spinkit.skLine);

  // constructor
  constructor() {
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          // if (this.router.url.includes('/login')) {
          //   this.isSpinnerVisible = false;
          //   return;
          // }
          this.isSpinnerVisible = false;
        } else if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          setTimeout(() => {
            this.isSpinnerVisible = false;
          });
        }
      },
      () => {
        setTimeout(() => {
          this.isSpinnerVisible = false;
        });
      }
    );
  }

  // life cycle event

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }
  ngOnDestroy(): void {
    this.isSpinnerVisible = false;
  }
}
